import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of, Subject } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config-service';
import { EntityType } from '../../models/enums/entityType';
import { AuthService } from './../auth.service';

@Injectable()
export class LocksService {

  refreshTimer: any;
  currentUserId: string;
  entityType: EntityType;
  entityId: string;
  entityIsLocked = new Subject();

  configService = inject(ConfigService);

  constructor(private http: HttpClient) {
  }

  startEntityLock(entityType: EntityType, entityId: string) {
    this.entityType = entityType;
    this.entityId = entityId;
    if (this.refreshTimer) {
      this.stopEntityLock();
    }
    this.lockEntityHeartbeat();
    this.refreshTimer = setInterval(() => {
      this.lockEntityHeartbeat();
    }, 15000);
  }

  lockEntityHeartbeat() {
    this.lockEntity(this.currentUserId, this.entityType, this.entityId).subscribe(isLocked => {
      if (isLocked === true) {
        this.entityIsLocked.next(isLocked);
      }
    });
  }

  stopEntityLock() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = undefined;
    }
  }

  lockEntity(userId: string, entityType: EntityType, entityId: string): Observable<boolean> {
    const url = this.configService.readConfig().baseUrlInfrastructure + '/locks/lockentity';

    const dto = {
      entityId: entityId,
      entityType: entityType
    };
    return this.http.post<boolean>(url, dto);
  }
}
